import { INameId } from '@modeso/types__aumico-lib-core-be';
import { IFinancialLineItemExtendedDTO } from '@modeso/types__aumico-lib-settings-be';

export interface IFinancialLineItemFormData extends Omit<IFinancialLineItemExtendedDTO, 'cashflow' | 'type'> {
    cashflowOption: INameId;
    typeOption: INameId;
}
